import { ArrowLeft } from "lucide-react";
import StepIndicator from "../components/booking/StepIndicator";
import SuccessPage from "../components/booking/SuccessPage";
import Step1 from "../components/booking/steps/Step1";
import Step2 from "../components/booking/steps/Step2";
import Step3 from "../components/booking/steps/Step3";
import Step4 from "../components/booking/steps/Step4";
import Step5 from "../components/booking/steps/Step5";
import useCustomerForm from "../hooks/useCustomerForm";
import { useEffect } from "react";

function CustomerFormPage2() {
  const {
    formik,
    currentStep,
    isSuccess,
    setIsSuccess,
    closeModal,
    handleNext,
    handleBack,
    disabled,
    data,
    identity,
    identityImage,
    drivingLicense,
    familyCard,
    socialMedia,
    businessId,
    currentLanguage,
    hotel,
    flight,
    priceCalculate,
    bookingData,
    paymentLink,
    handleCreatePayment,
    handleIdentityImage,
    handleDrivingLisence,
    handleFamilyCard,
    handleSocialMedia,
    handleBusinessId,
    handleHotel,
    handleFlight,
    handleSelectIdentity,
    handleNavigateBack,
    insurances,
    insuranceLoading,
    navigate,
    t,
  } = useCustomerForm();

  useEffect(() => {
    if (!data) {
      navigate("/");
    }
  }, [data]);

  if (!data) {
    return null;
  }

  if (isSuccess) {
    return (
      <div>
        <div className="booking-modal__title">
          <h2>{t("booking_confirmation") || "Booking Confirmation"}</h2>
          {/* <i onClick={closeModal} className="fa-solid fa-xmark"></i> */}
        </div>
        <SuccessPage paymentLink={paymentLink} closeModal={closeModal} t={t} />
      </div>
    );
  }

  return (
    <div>
      <div className="bg-[#1b2335] px-2 w-full flex text-white justify-between py-6 text-4xl font-semibold">
        <button onClick={handleNavigateBack}>
          <ArrowLeft />
        </button>
        <h2>{t("complete_reservation")}</h2>
        <div />
      </div>
      <div className="m-auto max-w-7xl">
        <StepIndicator currentStep={currentStep} t={t} />

        <div onSubmit={formik.handleSubmit}>
          {currentStep === 1 && (
            <Step1
              formik={formik}
              data={data}
              insurances={insurances}
              insuranceLoading={insuranceLoading}
              priceCalculate={priceCalculate}
              t={t}
            />
          )}
          {currentStep === 2 && <Step2 formik={formik} data={data} priceCalculate={priceCalculate} t={t} />}
          {currentStep === 3 && (
            <Step3
              formik={formik}
              data={data}
              identity={identity}
              handleSelectIdentity={handleSelectIdentity}
              identityImage={identityImage}
              handleIdentityImage={handleIdentityImage}
              drivingLicense={drivingLicense}
              handleDrivingLisence={handleDrivingLisence}
              familyCard={familyCard}
              handleFamilyCard={handleFamilyCard}
              socialMedia={socialMedia}
              handleSocialMedia={handleSocialMedia}
              businessId={businessId}
              handleBusinessId={handleBusinessId}
              hotel={hotel}
              flight={flight}
              handleHotel={handleHotel}
              handleFlight={handleFlight}
              t={t}
            />
          )}
          {currentStep === 4 && (
            <Step4
              formik={formik}
              data={data}
              priceCalculate={priceCalculate}
              t={t}
              currentLanguage={currentLanguage}
              onSubmit={formik.handleSubmit}
              disabled={disabled}
              bookingData={bookingData}
            />
          )}
          {currentStep === 5 && (
            <Step5
              bookingData={bookingData}
              paymentLink={paymentLink}
              handleCreatePayment={handleCreatePayment}
              disabled={disabled}
              setIsSuccess={setIsSuccess}
              t={t}
            />
          )}

          {/* Navigation Buttons */}
          {currentStep < 5 && currentStep !== 4 && (
            <div className="flex gap-4 px-4 pb-6 mt-6">
              {currentStep > 1 && (
                <button
                  type="button"
                  onClick={handleBack}
                  className="flex-1 px-6 py-6 font-bold text-gray-800 transition-colors bg-gray-300 rounded hover:bg-gray-400"
                >
                  {t("back") || "Back"}
                </button>
              )}

              <button
                type="button"
                onClick={handleNext}
                className="flex-1 px-6 py-6 font-bold text-white transition-colors bg-[#f5272b] rounded hover:bg-red-600"
              >
                {t("next") || "Next"}
              </button>
            </div>
          )}

          {/* Back Button untuk Step 4 */}
          {currentStep === 4 && (
            <div className="flex gap-4 px-4 pb-6 mt-6">
              <button
                type="button"
                onClick={handleBack}
                className="flex-1 px-6 py-6 font-bold text-gray-800 transition-colors bg-gray-300 rounded hover:bg-gray-400"
              >
                {t("back") || "Back"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerFormPage2;
